export default 'Copropriétés — MaPrimeRénov’ & CEE | Solution Éco France';
